//import 'whatwg-fetch';
//import store from 'store';
//import basicAuth from 'config';
import isEmpty from 'lodash/isEmpty';

// handle exception here
export const handleResponse = (response, currentAction, resData, routeUrl) => {

  if((window.location.href.includes('feed') == false) && (window.location.href.includes('chat') == false) && (localStorage.getItem('userpage') != 'timeline')){ 
    
    loader(false);
  }
 
  pageloader(false);
  if (response.status === 200) {
    let res = response.data.response;
    if((response.config.url.includes('registration_basic') == true) || 
       (response.config.url.includes('registration') == true) || 
       (response.config.url.includes('login') == true) || 
       (response.config.url.includes('otp_validation') == true)|| 
       (response.config.url.includes('resend_otp') == true) ||
       (response.config.url.includes('resend_otp_for_email_verification') == true)){
      Object.assign(res, {
        req_status : response.data.status,
        req_message: response.data.message,
        timestamp  : Date.now()
      })
    }
    return res;
  }
  // If invalid jwt token the page will get redirect to login.
  /* if (response.status === 401) {
    document.getElementById('preloader').style.display = 'block';
    const resObject = {
      authToken: sessionStorage.getItem('authToken'),
      jwtToken: sessionStorage.getItem('jwtToken'),
      deviceId: sessionStorage.getItem('deviceId'),
    };
    fetch(`${apiLoginURLPrefix}/athlete/login/refresh`, {
      method: 'post',
      body: JSON.stringify(resObject),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${basicAuth.authSecret}`,
      },
    })
      .then(res => res.json())
      .then(res => {
        sessionStorage.setItem('jwtToken', res.jwt);
        if (!isEmpty(res.jwt)) {
          setTimeout(() => {
            if (resData !== 'false') {
              store.dispatch(currentAction(resData)).then(res => {
                if (!isEmpty(routeUrl) && routeUrl !== '/routes') {
                  location.href = routeUrl + res.route.id;
                } else if (routeUrl === '/routes') {
                  location.href = '/routes';
                } else {
                  location.reload();
                }
                document.getElementById('preloader').style.display = 'none';
              });
            }
            if (resData === 'false') {
              store.dispatch(currentAction()).then(res => {
                location.reload();
                // document.getElementById('preloader').style.display = 'none';
              });
            }
          }, 5000);
        } else {
          sessionStorage.clear();
          location.href = '/';
        }
      });
  } */
  if (response.status === 400) {
    return response.data.response;
  }
  // Return error
  const error = new Error(response);
  error.response = response.code;
  throw error;
};

export const loader = (status = false) => {
 
  const preloader = (document.getElementById('preloader'));
 
  if(preloader != null){
   if(status) {
      document.getElementById('preloader').style.display = 'block';
    }else{
      document.getElementById('preloader').style.display = 'none';
    }
  }
};

export const pageloader = (status = false) => {
  const pageloader = (document.getElementById('pageloader'));

  if(pageloader != null){
    if(status) {
      document.getElementById('pageloader').style.display = 'block';
    }else{
      document.getElementById('pageloader').style.display = 'none';
    }
  }
};

export const chatloader = (status = false) => {
  const circularprogress = (document.getElementById('circularprogress'));
  if(circularprogress != null){
    if(status) {
      
        document.getElementById('circularprogress').style.display = 'block';
      }else{
     
        document.getElementById('circularprogress').style.display = 'none';
      
    }
  }
};